<template>
  <div
    class="head"
    v-if="user"
    :class="{
      'mx-0':
        (addPostModel.sourceType &&
          addPostModel.sourceType == 'data-team-tweets') ||
        (addPostModel.userId && addPostModel.userId.includes('rssfeed')),
    }"
  >
    <figure
      class="profile_avatar"
      v-if="
        addPostModel.sourceType == 'data-team-tweets' ||
        (addPostModel.userId && addPostModel.userId.includes('rssfeed'))
      "
    >
      <img
        :src="addPostModel.rssFeedDetail.profilePicture"
        v-if="addPostModel.rssFeedDetail"
        @error="(ev) => changePictureOnError(ev)"
      />
      <img
        src="https://firebasestorage.googleapis.com/v0/b/internaldev-361116.appspot.com/o/images%2Ftwitter-profile.jpg?alt=media&token=4eeb67d3-baed-4019-8681-08d1e8b086ea"
        v-else
      />
    </figure>
    <ProfileAvatarComponent
      v-else-if="user.profilePicture"
      :profileImage="user.profilePicture"
      :userId="user._id"
      :user="user"
      :fromOutside="fromOutside"
      :class="[!isSavedPost ? 'mini connection' : '', isSmallScreen && 'mini']"
      :badges="false"
      :border="true"
      :isDetailPopUp="isSavedPost"
      @click.stop="$emit('avatar-click')"
    />
    <h6 class="info_profile" @click.stop="goToProfile()">
      <div
        class="profile_feeling"
        v-if="
          addPostModel.sourceType == 'data-team-tweets' ||
          (addPostModel.userId && addPostModel.userId.includes('rssfeed'))
        "
      >
        <template v-if="addPostModel.rssFeedDetail">
          {{ addPostModel.rssFeedDetail.name }}
        </template>
        <template v-else> Twitter </template>
      </div>
      <div class="profile_feeling" v-else>
        {{ user.fullName }}
      </div>
      <span v-if="addPostModel.sourceType == 'rssfeed'">
        <b> News </b>
        <!-- <span v-if="postType" class="momentTime">· {{ momentTime }} </span> -->
      </span>
      <span v-else-if="addPostModel.sourceType == 'data-team-tweets'">
        <b> Twitter Feed </b>
        <!-- <span v-if="postType" class="momentTime">· {{ momentTime }} </span> -->
      </span>
      <span v-else-if="addPostModel.sourceType == 'twitter-tweet'">
        {{ $t("common.common.shared") }} <b>Twitter Tweet</b> with
        {{ postPrivacy }}
        <!-- <span v-if="postType" class="momentTime">· {{ momentTime }} </span> -->
      </span>
      <span v-else-if="postSubType && isSavedPost">
        <!-- {{$t("common.common.shared")}} {{ startsWithVowel(postType) ?  $t("common.common.an")  :  $t("common.common.a")  }} -->
        <b>{{ postSubType=='short'?postSubType.toUpperCase() +" POST" :postSubType.toUpperCase()}}</b> {{ $t("common.common.with") }}
        {{ $t(`common.common.${postPrivacy}`) }}
        <!-- <span v-if="postType" class="momentTime">· {{ momentTime }} </span> -->
      </span>
      <span v-else> @{{ user.userName }} </span>
    </h6>
    <div class="avatar" v-if="postType && isSavedPost">
      <template
        v-if="addPostModel.userId && addPostModel.userId.includes('rssfeed')"
      >
        <IconComponent path="/explore" icon="icon-news.svg" />
      </template>
      <template v-else>
        <IconComponent
          v-if="
            addPostModel.postOnTwitter ||
            addPostModel.sourceType == 'data-team-tweets' ||
            addPostModel.sourceType == 'twitter-tweet'
          "
          className="trademark "
          path=""
          icon="icon-twitter.svg"
        />
        <IconComponent
          v-if="
            addPostModel.postOnTwitter ||
            (addPostModel.sourceType != 'data-team-tweets' &&
              addPostModel.sourceType != 'twitter-tweet')
          "
          path=""
          className="trademark "
          icon="Header_Logo.svg"
        />
      </template>
      <span class="time">{{ momentTime }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import { computed, defineComponent, onMounted, ref, watch } from "vue";
import IconComponent from "@/components/IconComponent.vue";
import utilService from "@/services/util.service";
import ProfileAvatarComponent from "@/components/ProfileAvatarComponent.vue";
import { PostSourceType } from "../../models/posts.model";
import router from "@/router/router";
import { RouteEnum } from "@/router/routeNames";
import { useStockSocket } from "@/composables/stock_socket.composable";
import storageService from "@/services/storage.service";
import { popModal } from "jenesius-vue-modal";
// import { useUserSocket } from "@/composables/userInformation_socket.composable";
TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");

export default defineComponent({
  components: {
    IconComponent,
    ProfileAvatarComponent,
  },
  props: [
    "fromOutside",
    "user",
    "postId",
    "postType",
    "postSubType",
    "addPostModel",
    "postPrivacy",
    "isSavedPost",
  ],
  emits: ["avatar-click"],
  setup(props) {
    const momentTime = ref<string>("");

    const isSavedPost = ref<Boolean>(props.isSavedPost ?? true);

    onMounted(() => {
      if (props.addPostModel && props.addPostModel.modifiedOn) {
        updateMomentTime();
        setInterval(() => {
          updateMomentTime();
        }, 60 * 1000);
      }
    });

    const goToProfile = () => {
      if (props.addPostModel) {
        if (props.addPostModel.userId == PostSourceType.RSSFEED) {
          if (
            props.addPostModel &&
            props.addPostModel.metaData &&
            props.addPostModel.metaData.length
          ) {
            window.open(props.addPostModel.metaData[0].url, "_blank");
          }
        } else if (props.addPostModel.sourceType == PostSourceType.DATATEAM) {
          if (
            props.addPostModel &&
            props.addPostModel.rssFeedDetail &&
            props.addPostModel.rssFeedDetail.profileUrl
          ) {
            window.open(props.addPostModel.rssFeedDetail.profileUrl, "_blank");
          }
        } else {
          if (props.user) {
            let token = storageService.getToken();
            if (token) {
              popModal();
              router.push({
                name: RouteEnum.profile,
                params: { username: props.user.userName },
              });
            } else {
              popModal();
              router.push({
                name: "publicProfileShortChild",
                params: { username: props.user.userName },
              });
            }
          }
        }
      } else {
        if (props.user) {
          router.push({
            name: RouteEnum.profile,
            params: { username: props.user.userName },
          });
        }
      }
    };

    const updateMomentTime = () => {
      var dateTimestamp = props.addPostModel.modifiedOn;
      if (props.addPostModel.userId == PostSourceType.RSSFEED) {
        dateTimestamp = parseFloat(props.addPostModel._id);
        if (!dateTimestamp) {
          dateTimestamp = props.addPostModel.modifiedOn;
        }
      }
      momentTime.value = timeAgo.format(
        new Date(dateTimestamp),
        "mini-now"
      ) as string;
    };

    const getFeelingImage = (url: string) =>
      utilService.getImageUrl(url, "/feelings");

    const getImageUrl = utilService.getImageUrl;

    const changePictureOnError = (er: any) => {
      er.srcElement.src = utilService.getImageUrl(
        "dummy_profile_twitter.png",
        null
      );
      // if(props.addPostModel.rssFeedDetail.coverImage){
      //   er.srcElement.src = props.addPostModel.rssFeedDetail.coverImage;
      // }
    };

    const startsWithVowel = (str: string) => {
      const vowels = "aeiouAEIOU";
      return vowels.includes(str.charAt(0));
    };

    const isSmallScreen = computed(utilService.isSmallScreen);

    const { getUsersByID, userDataInfo, userIds } = useStockSocket();

    // watch(props, (newValue, oldValue) => {
    //   userIds.value.push(props.addPostModel!.userId);
    //   await getUsersByID();
    //   updateUsersData();
    // });

    onMounted(async () => {
      userIds.value.push(props.addPostModel!.userId);
      await getUsersByID();
      updateUsersData();
    });

    watch(
      () => props.addPostModel!,
      () => {
        updateUsersData();
      },
      { deep: true }
    );

    const updateUsersData = () => {
      const userId = props.addPostModel!.userId;
      if (userId && userDataInfo.value[userId]?.profilePicture) {
        let info = utilService.getUserProfilePicture(
          userDataInfo.value[userId]._id!,
          userDataInfo.value[userId].profilePicture,
          "male",
          false,
          false
        );
        props.user.profilePicture = info;
      }
    };

    return {
      momentTime,
      getFeelingImage,
      changePictureOnError,
      getImageUrl,
      goToProfile,
      isSavedPost,
      startsWithVowel,
      isSmallScreen,
    };
  },
});
</script>

<style lang="scss" scoped>
@media (min-width: 1280px) and (max-width: 1891px) {
  .info_profile {
    .profile_feeling {
      font-size: var(--font-2xs);
    }

    span {
      font-size: var(--font-2xs) !important;
    }
  }
}
</style>
